import { createContext, useContext } from "react";
import { ChatContextType } from "duck/ui/chat/types";

export const ChatContext = createContext<ChatContextType | undefined>(
  undefined
);

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error("useChatContext must be used within a ChatProvider");
  }

  return context;
};
